import { render, staticRenderFns } from "./UserInformationCard.vue?vue&type=template&id=b69af394"
import script from "./UserInformationCard.vue?vue&type=script&lang=js"
export * from "./UserInformationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports